// Converts an array of variant combos into a grouped UI firendly structure fro the frontend
export function groupVariantOptions(variants = []) {
  const optionMap = {};

  variants.forEach((variant) => {
    //skip if variant is null or doesn't have an object 'options'
    if (!variant?.options || typeof variant.options !== "object") return;

    Object.entries(variant.options).forEach(([optionName, value]) => {
      if (!optionMap[optionName]) {
        optionMap[optionName] = new Set();
      }

      optionMap[optionName].add(value);
    });
  });

  return Object.entries(optionMap).map(([option, valueSet]) => ({
    variantOption: option,
    variantValues: Array.from(valueSet),
    isEditing: false, // optional, but useful for preloaded editing state
  }));
}